import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseGrid, BaseGridItem, } from '@awaze/design-system.components.base-grid';
import { Stack } from '@awaze/design-system.components.stack';
import { InputGroup } from './input-group';
/**
 * A group of form controls for the party size of a holiday. The `<InputGroup>` can also be used individually if more control over the layout is needed.
 * */
export const PartySizeInputs = ({ adultsConfig, childrenConfig, infantsConfig, formHooks, petsConfig, isStepper, labels = {
    infants: {
        validationMsg: 'Please choose how many infants are going',
        label: 'Infants',
        description: 'Aged up to 2',
    },
    children: {
        validationMsg: 'Please choose how many children are going',
        label: 'Children',
        description: 'Aged 2-17',
    },
    adults: {
        validationMsg: 'Please choose how many adults are going',
        label: 'Adults',
        description: 'Aged 18+',
    },
    pets: {
        validationMsg: 'Please choose how many pets are going',
        label: 'Pets',
    },
}, }) => (_jsx(BaseGrid, { flush: true, children: _jsx(BaseGridItem, { columns: 12, children: _jsxs(Stack, { spacing: 20, isHorizontal: !isStepper, equalChildren: !isStepper, fullWidth: true, children: [adultsConfig.max > 0 && (_jsx(InputGroup, { formHooks: formHooks, isRequired: true, max: adultsConfig.max, min: adultsConfig.min, isStepper: isStepper, labels: labels.adults, fieldName: "adult" })), childrenConfig.max > 0 && (_jsx(InputGroup, { formHooks: formHooks, max: childrenConfig.max, min: childrenConfig.min, isStepper: isStepper, labels: labels.children, fieldName: "child" })), infantsConfig.max > 0 && (_jsx(InputGroup, { formHooks: formHooks, max: infantsConfig.max, min: infantsConfig.min, labels: labels.infants, fieldName: "infant", isStepper: isStepper })), petsConfig.max > 0 && (_jsx(InputGroup, { formHooks: formHooks, max: petsConfig.max, min: petsConfig.min, isStepper: isStepper, labels: labels.pets, fieldName: "pets" }))] }) }) }));
//# sourceMappingURL=party-size-inputs.js.map